import { initializeApp } from "firebase/app";
// import { getMessaging } from "firebase/messaging";
// import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import {  ref } from 'vue';

const firebaseConfig = {
  apiKey: "AIzaSyDRubSM3e6_uQp4h25GI_CR5ylKHPkSmPM",
  authDomain: "aurora-b9b5e.firebaseapp.com",
  projectId: "aurora-b9b5e",
  storageBucket: "aurora-b9b5e.firebasestorage.app",
  messagingSenderId: "92131899379",
  appId: "1:92131899379:web:82f07957c27bb058abc486"
};

const fb = initializeApp(firebaseConfig);

// const tempToken = ref("123456")

// Get registration token. Initially this makes a network call, once retrieved
// subsequent calls to getToken will return from cache.
// const messaging = getMessaging(fb);

// onMessage(messaging, (payload) => {
//   console.log('Message received. ', payload);
//   // ...
// });

// getToken(messaging, { vapidKey: 'BBaFCQ_NrGLHNo4ULInXKxl7kxWUyygfaxebeFYP2PaRRxYTMu17cPY-tKH2UMWdM3YIwe-5lVvrc0LK-a8BJII' }).then((currentToken) => {
//     // function requestPermission() {
//     //     console.log('Requesting permission...');
//     //     Notification.requestPermission().then((permission) => {
//     //       if (permission === 'granted') {
//     //         console.log('Notification permission granted.');
//   if (currentToken) {
//     // Send the token to your server and update the UI if necessary
//     console.log("Token is:",currentToken);
//     // tempToken = currentToken;
//     // tempToken.value = currentToken
//     // ...
//   } else {
//     // Show permission request UI
//     console.log('No registration token available. Request permission to generate one.');
//     // ...
//   }
// }).catch((err) => {
//   console.log('An error occurred while retrieving token. ', err);
//   // ...
// });

// export default {
//     fb,
//     messaging
//   }
// export default messaging;
export default fb;
